import straivLogoLight from "@/assets/straiv-logo-light.png";
import straivLogoFallback from "@/assets/straiv-logo.png";
import { useState } from "react";
import { IS_DEV_APP } from "@/lib/env";

/** Straiv boot loader — logo + green ring on dark background (phone app splash). */
export function StraivAppLoader({ fullScreen = true }: { fullScreen?: boolean }) {
  const [logoSrc, setLogoSrc] = useState(straivLogoLight);

  return (
    <div
      className={
        fullScreen
          ? "min-h-screen bg-[#1f1f1f] flex flex-col items-center justify-center"
          : "flex flex-col items-center justify-center py-8"
      }
    >
      <img
        src={logoSrc}
        alt="Straiv"
        className="h-48 w-auto max-w-[600px] object-contain mb-6"
        onError={() => {
          if (logoSrc !== straivLogoFallback) setLogoSrc(straivLogoFallback);
        }}
      />
      <div
        className="h-[46px] w-[46px] rounded-full animate-spin"
        style={{
          background:
            "conic-gradient(from 0deg, hsl(160 100% 50%), hsl(160 100% 40%), hsl(160 100% 50% / 0.12), hsl(160 100% 50%))",
          WebkitMask: "radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px))",
          mask: "radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px))",
        }}
        aria-hidden
      />
      {IS_DEV_APP && (
        <p className="mt-5 rounded-full bg-amber-400 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wider text-black">
          DEV · not production
        </p>
      )}
    </div>
  );
}
